import { render, staticRenderFns } from "./string-translation.vue?vue&type=template&id=c8dfd984&"
import script from "./string-translation.vue?vue&type=script&lang=js&"
export * from "./string-translation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports